<template>
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <mask :id="maskId" fill="white">
            <path
                d="M20 0C20 1.31322 19.7413 2.61358 19.2388 3.82683C18.7362 5.04009 17.9997 6.14248 17.0711 7.07107C16.1425 7.99965 15.0401 8.73625 13.8268 9.2388C12.6136 9.74134 11.3132 10 10 10C8.68678 10 7.38642 9.74134 6.17317 9.23879C4.95991 8.73625 3.85752 7.99965 2.92893 7.07107C2.00035 6.14248 1.26375 5.04009 0.761204 3.82683C0.258657 2.61358 -1.14805e-07 1.31322 0 -9.53674e-07L10 0H20Z" />
        </mask>
        <path
            d="M20 0C20 1.31322 19.7413 2.61358 19.2388 3.82683C18.7362 5.04009 17.9997 6.14248 17.0711 7.07107C16.1425 7.99965 15.0401 8.73625 13.8268 9.2388C12.6136 9.74134 11.3132 10 10 10C8.68678 10 7.38642 9.74134 6.17317 9.23879C4.95991 8.73625 3.85752 7.99965 2.92893 7.07107C2.00035 6.14248 1.26375 5.04009 0.761204 3.82683C0.258657 2.61358 -1.14805e-07 1.31322 0 -9.53674e-07L10 0H20Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="1.48707"
            :mask="`url(#${maskId})`" />
        <path
            d="M9.89453 9.80469C9.94553 9.73127 10.0545 9.73127 10.1055 9.80469L16.9453 19.6768C17.0041 19.7617 16.9431 19.8777 16.8398 19.8779H3.16016C3.05689 19.8777 2.99585 19.7617 3.05469 19.6768L9.89453 9.80469Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.743536" />
    </svg>
</template>

<script setup lang="ts">
import { useId } from "vue";

const maskId = useId();
</script>
